import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HowIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HowIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 7.29394C10.5405 7.29394 9.35303 6.10644 9.35303 4.64697C9.35303 3.1875 10.5405 2 12 2C13.4595 2 14.647 3.1875 14.647 4.64697C14.647 6.10644 13.4595 7.29394 12 7.29394ZM12 2.99999C11.0918 2.99999 10.353 3.73876 10.353 4.64696C10.353 5.55516 11.0918 6.29393 12 6.29393C12.9082 6.29393 13.647 5.55516 13.647 4.64696C13.647 3.73876 12.9082 2.99999 12 2.99999Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 22C9.35156 22 7.19727 19.8457 7.19727 17.1973C7.19727 14.5488 9.35157 12.3945 12 12.3945C14.6484 12.3945 16.8027 14.5488 16.8027 17.1973C16.8027 19.8457 14.6484 22 12 22ZM12 13.3945C9.90332 13.3945 8.19727 15.1006 8.19727 17.1972C8.19727 19.2939 9.90332 21 12 21C14.0967 21 15.8027 19.2939 15.8027 17.1972C15.8027 15.1006 14.0967 13.3945 12 13.3945Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 13.3945C11.7236 13.3945 11.5 13.1709 11.5 12.8945V6.86376C11.5 6.58739 11.7236 6.36376 12 6.36376C12.2764 6.36376 12.5 6.58739 12.5 6.86376V12.8945C12.5 13.1709 12.2764 13.3945 12 13.3945Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.4888 18.8906C11.3564 18.8906 11.229 18.8379 11.1352 18.7441L10.0439 17.6528C9.84863 17.4575 9.84863 17.1411 10.0439 16.9458C10.2392 16.7505 10.5557 16.7505 10.751 16.9458L11.4717 17.6665L13.1645 15.8037C13.3506 15.6001 13.668 15.5859 13.8711 15.77C14.0752 15.9561 14.0903 16.272 13.9048 16.4766L11.8589 18.7271C11.7666 18.8281 11.6372 18.8872 11.5005 18.8906H11.4888Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HowIcon;
